import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('management-reports-parcel-flow', storeModule.createStoreModule('management-reports-parcel-flow'))
